import { CaseResult } from 'app/area/case-report/case-listing/types-store';
import * as React from 'react';
import { ElementLoader } from 'ui';
import { Paginator } from 'ui/common/paginator';
import { FavouriteDefinition } from 'app/types-shared';
import { BowtieListingResultListItem } from 'app/area/case-report/bowtie-listing/components/bowtie-listing-result-list-item';

interface BowtieListingResultListProps {
  translation: any;
  results?: CaseResult[];
  fetching: boolean;
  shouldPaginate: boolean;
  maxOptionsPerPage: number;
  currentPage: number;
  numberOfPages: number;
  first: any;
  previous: any;
  next: any;
  last: any;
  workingDefinition?: FavouriteDefinition;
}

export const BowtieListingResultList = ({
  results,
  fetching,
  translation,
  shouldPaginate,
  maxOptionsPerPage,
  currentPage,
  numberOfPages,
  first,
  previous,
  next,
  last
}: BowtieListingResultListProps) => {

  const noResults = !!results && results.length === 0;
  const textPageOf = translation.text_page_of;

  return (
    <div>
      <div className="bowtie-listing-result">
        {results && results.slice(0, maxOptionsPerPage).map(item =>
          <BowtieListingResultListItem resultItem={item} {...{ translation }} />)
        }
      </div>
      {shouldPaginate &&
        <Paginator
          {...{ first, previous, next, last, textPageOf, currentPage, numberOfPages }}
        />
      }
      {fetching
        ? <ElementLoader />
        : noResults && <div>{translation.search_no_hits}</div>}
    </div>
  );
};
